import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddCompanyHolidaysWizard.scss';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import {
  createCompanyHoliday,
  listCompanyHolidays,
} from '../redux/actions/table/company_holidays';
import AddCompanyIcon from '../assets/images/add-company-60x60.svg';
import AddCompanyHolidaysForm from '../forms/add_company_holidays_wizard/AddCompanyHolidaysForm';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['company_holidays'],
}))
@subscribe(Localization, 'localization')
class AddCompanyHolidaysWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    return validateForm(
      createCompanyHoliday(formData).then(({ response }) => {
        listCompanyHolidays();

        setNotification(__('wizard.add-company-holiday.confirm'));

        this.props.onClose();
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('wizard.add-company-holidays.title.create-new')}</span>
            <span>{__('wizard.add-company-holidays.subtitle.create-new')}</span>
          </div>
          <div className={styles.right}>
            <AddCompanyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddCompanyHolidaysForm onSubmit={this._handleSubmit} />
        </div>
      </>
    );
  }
}

export default AddCompanyHolidaysWizard;
